import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const CHECKOUT_URL = 'https://digifactorymax.net/cart/57830545064200:1';
declare global {
  interface Window {
    fbq?: any;
  }
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  subtext?: string;
  className?: string;
}
export function Button({
  children,
  subtext,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Fire Meta Pixel AddToCart event on every CTA click.
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'The 48-Hour Airbnb Cleanup Protocol',
        content_category: 'Digital Product',
        content_ids: ['airbnb-cleanup-protocol'],
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }
    if (onClick) {
      onClick(e);
    } else {
      window.location.href = CHECKOUT_URL;
    }
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-143">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handleClick} className="group relative w-full sm:w-auto flex items-center justify-center gap-3 bg-brand-yellow hover:bg-brand-yellowHover text-brand-dark px-8 py-5 rounded-lg font-display text-2xl uppercase tracking-wider transition-colors shadow-[0_0_40px_rgba(250,204,21,0.3)] hover:shadow-[0_0_60px_rgba(250,204,21,0.5)]" {...props} data-id="element-144">
        {children}
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" strokeWidth={3} data-id="element-145" />
      </motion.button>
      {subtext && <p className="mt-3 text-sm font-medium text-gray-400 text-center" data-id="element-146">
          {subtext}
        </p>}
    </div>;
}